import { Fragment } from 'react';
import { medicalBookIcon } from '../../../components/common/Icons';

type Props = {
    handleCta?: () => void;
};

const mhBookIcon = medicalBookIcon();

const VitalsEmpty: React.FC<Props> = ({ handleCta }) => {
    return (
        <Fragment>
            <p className="text-13 w-168 m-auto text-center mt-48 mb-32 text-darwin-neutral-800 font-400">
                You can see your patient's{' '}
                <span
                    onClick={handleCta}
                    className="font-700 text-darwin-accent-symptoms-blue-800 cursor-pointer hover:underline hover:underline-darwin-accent-symptoms-blue-800"
                >
                    vitals
                </span>{' '}
                here
            </p>
            <div className="text-13 flex-col space-y-10 m-22 border border-darwin-accent-examination-findings-sky-blue-300 bg-darwin-accent-examination-findings-sky-blue-200 p-12 text-darwin-accent-examination-findings-sky-blue-900">
                <div className="flex items-center justify-between">
                    <p>Temperature</p>
                    <div className="flex space-x-11">
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <p>Blood Pressure</p>
                    <div className="flex space-x-11">
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <p>Hemoglobin</p>
                    <div className="flex space-x-11">
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <p>HbA1c</p>
                    <div className="flex space-x-11">
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                        <p className="w-32 h-7 rounded-full bg-darwin-accent-examination-findings-sky-blue-300"></p>
                    </div>
                </div>
            </div>
            {handleCta && (
                <button
                    onClick={handleCta}
                    className="flex items-center space-x-8 font-700 text-14 border border-darwin-primary-500 p-9 px-16 m-auto rounded-4 text-darwin-primary-500"
                >
                    <span>{mhBookIcon}</span>
                    <span>Add Vitals</span>
                </button>
            )}
        </Fragment>
    );
};

export default VitalsEmpty;
